<!-- /**
 * @author Ketan Shetye
 * @created 2025-11-07
 */ -->
<div class="main-container">
  <wm-common-text [data]="{text:'My summary'}"></wm-common-text>
  <div class="summary-sub-text">
    <wm-common-text [data]="{text:'Click any summary card to sort My Applications. To reset My Applications list, click “Clear” on summary card.'}"></wm-common-text>
  </div>
  <div class="summary-cards-container">
    @if (fetchError) {
    <div class="summary-fetch-error-container">
      <wm-common-icon [data]="{iconName:staticSummaryDetails.errorIcon}"></wm-common-icon>
      <wm-common-text [data]="{text:'An error occurred while loading the summary cards. Please try again.'}"></wm-common-text>
    </div>
    }@else {
    @if (summaryList?.length) {
    @for (summary of summaryList; track $index) {
    <!-- <div class="summary-card" [ngClass]="{ 'hover-summary-card': summary.variant === 'alert' }" (click)="onSummaryCardClick(summary.command,summaryDetails.activeSummaryFilter,summary.variant)" > -->
    <!-- Added by amisha on 05/07/2027 to expose only interactive summary cards in the keyboard tab order.
         Reason: alert cards need focus, button semantics, and keyboard activation while non-action cards should stay static. -->
    <div class="summary-card"
      [ngClass]="{ 'hover-summary-card': summary.variant === 'alert' }"
      [attr.tabindex]="isInteractiveSummaryCard(summary.variant) ? 0 : -1"
      [attr.role]="isInteractiveSummaryCard(summary.variant) ? 'button' : null"
      [attr.aria-pressed]="isInteractiveSummaryCard(summary.variant) && summaryDetails.activeSummaryFilter === summary.command"
      (click)="isInteractiveSummaryCard(summary.variant) && onSummaryCardClick(summary.command, summary.variant)"
      (keydown)="onSummaryCardKeydown($event, summary.command, summary.variant)">
      <div class="summary-header" [ngClass]="{ 'alert-summary-header': summary.variant === 'alert' }">
        <wm-common-icon [data]="{iconName:summary.icon}"></wm-common-icon>
        <wm-common-text [data]="{text:summary.title}"></wm-common-text>
      </div>
      <div class="summary-body-footer-container"
        [ngClass]="{ 'active-summary-filter': summary.variant === 'alert' && summaryDetails.activeSummaryFilter && summaryDetails.activeSummaryFilter === summary.command }">
        <div class="summary-body" [ngClass]="{ 'alert-summary-body': summary.variant === 'alert' }">
          <wm-common-text [data]="{text:summary.text}"></wm-common-text>
        </div>

        <div class="summary-footer" [ngClass]="{ 'alert-summary-footer': summary.variant === 'alert' }">
          @if (summary.variant === 'alert') {
          <!-- Added by Amisha on 05/25/2026.
               Reason: the renew summary card shows a navigation CTA to My Renewals,
               while the other alert cards keep the existing filter/reset labels. -->
          <wm-common-button
            [data]="{text: getSummaryActionLabel(summary)}"></wm-common-button>
          }
        </div>
      </div>
    </div>
    }
    }@else {
    <div class="skeleton-laptop-view">
      <ngx-skeleton-loader count="5" appearance="circle"
        [theme]="{ height: '150px', width: '16.67%',borderRadius:'15px' }" />
    </div>
    <div class="skeleton-tablet-view">
      <ngx-skeleton-loader count="4" appearance="circle"
        [theme]="{ height: '150px', width: '20%',borderRadius:'15px' }" />
    </div>
    <div class="skeleton-mobile-view">
      <ngx-skeleton-loader count="2" appearance="circle"
        [theme]="{ height: '150px', width: '45%',borderRadius:'15px' }" />
    </div>
    }
    }



  </div>
</div>
